import { useCallback } from 'react';
import { useNewRewardsApi } from 'Shared/services/Api';
import { GetRewardsEnrollmentResponse } from '@clearcover/core-app-types';
import { env } from 'Shared/constants/env';

export type RewardsEnrollmentProviderType = {
  rewardsEnrollmentResponse: GetRewardsEnrollmentResponse | null;
  rewardsEnrollmentLoading: boolean;
  refreshRewardsEnrollment(): Promise<GetRewardsEnrollmentResponse>;
};

const TEN_SECONDS = 10000;

const MOCK_ENROLLMENT: GetRewardsEnrollmentResponse = { isEnrolled: true };

export const useRewardsEnrollment = (): RewardsEnrollmentProviderType => {
  const [
    {
      data: rewardsEnrollmentResponse,
      loading: rewardsEnrollmentLoading,
      refetch: fetchRewardsEnrollment,
    },
  ] = useNewRewardsApi<GetRewardsEnrollmentResponse>(
    {
      url: `/v1/enrollment`,
      timeout: TEN_SECONDS,
    },
    false,
    false
  );

  const refreshRewardsEnrollment = useCallback(async () => {
    return (await fetchRewardsEnrollment()).data;
  }, [fetchRewardsEnrollment]);

  if (env.rewardsMockEnabled) {
    return {
      rewardsEnrollmentResponse: MOCK_ENROLLMENT,
      rewardsEnrollmentLoading: false,
      refreshRewardsEnrollment,
    };
  }

  return {
    rewardsEnrollmentResponse,
    rewardsEnrollmentLoading,
    refreshRewardsEnrollment,
  };
};
